import batteryUrl from '@/static/assets/car/driving/battery.svg';
import { LegacyText, font, themedColor } from '@lemonade-hq/cdk';
import React from 'react';
import styled from 'styled-components';

import { Gauge } from './Gauge';
import Image from 'next/image';

const SpeedContainer = styled.div`
  ${font('main')}

  position: absolute;
  background: #dedede;
  width: 390px;
  height: 140px;
  top: 790px;
  left: 639px;
  padding-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const Battery = styled(Image).attrs({
  src: batteryUrl.src,
  alt: 'Car Battery',
  width: 12,
  height: 23,
})`
  position: absolute;
  top: 30px;
  left: 90px;
`;

const StyledGauge = styled(Gauge)`
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
`;

const SpeedMeasurement = styled(LegacyText).attrs({ type: 'main' })`
  ${font('main', { fontSize: '11px', fontWeight: 600 })}

  color: ${themedColor('white')};
`;

const SpeedText = styled(LegacyText).attrs({ type: 'main' })`
  ${font('main', { fontSize: '60px', fontWeight: 700, lineHeight: '50px' })}
  color: #d1d1d1;
`;

const SpeedGauge: React.FC<{ speed: number }> = ({ speed }) => {
  return (
    <SpeedContainer>
      <Battery />
      <StyledGauge percent={speed} radius={90} />
      <SpeedMeasurement>MPH</SpeedMeasurement>
      <SpeedText>{speed}</SpeedText>
    </SpeedContainer>
  );
};

export default React.memo(SpeedGauge);
